<template>
  <div id="vantagens">
    <custom-lista
      v-if="!carregando"
      class="tratamento-vantagens-lista"
      :titulo="titulo"
      :fixa="fixa"
      :itens="itensRef"
      width="300"
      height="auto"
    />
  </div>
</template>

<script setup>
const { t, locale } = useI18n();
const carregando = ref(true);
const fixa = ref(true);
const props = defineProps({ tratamento: String });
const titulo = t("Quais as vantagens?");

const { data: vantagens } = await useFetch(
  `/api/site/tratamentos/${props.tratamento}/vantagens`,
  { headers: { "Content-Language": locale } }
);
let itensRef = ref([]);

onMounted(() => {
  Object.values(vantagens.value).forEach((item) => {
    itensRef.value.push({
      imagem: item.imagem,
      texto: item.descricao,
      class: "tratamento-vantagens-cartao",
    });
  });
  carregando.value = !itensRef.value.length > 0;
});
</script>

<script>
export default {
  name: "TratamentosVantagens",
};
</script>
